import styled from 'styled-components/macro';
import { SearchSelectHolderComponent } from '../../../../../common/dropDownComponents';
import * as colors from '../../../../../common/colorConstants';

export const SelectHolder = styled(SearchSelectHolderComponent)`
  margin: 25px 0px 10px 0px;
  width: 100% !important;
  margin-left: ${(props) => (props.label ? '3px' : '0px')};
  z-index: 20;
  position: relative;

  :nth-last-of-type(1) {
    z-index: 10;
  }

  .Select .Select-menu-outer {
    border-color: ${colors.lightGray21} !important;
    background-color: white !important;
  }

  .Filter .Select-arrow {
    color: black transparent transparent !important;
    border-top-color: #a1acc3 !important;
  }

  .Filter .Select-control {
    border-color: ${colors.lightGray21} !important;
    height: 25px !important;
  }
`;
